module.exports = __webpack_public_path__ + "static/media/on-app.5069e2ed.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/contentassets/on-app.svg
// module id = 168
// module chunks = 0